import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Text from '../../components/text/Text'
import routes from '../../router/routes'
import './PromotionCreated.css'
interface IPromotionState {
    idPromocion: number
}
const PromotionCreated = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { idPromocion } = location.state as IPromotionState
    return (
        <div className="background-promotion-created">
            <Text
                variant="promotion-page-title"
                label="Crear promoción"
                fontSize={27}
                fontWeight={400}
                color={'#184287'}
            />
            <div className="promotion-content">
                <div className="promotion-created-card">
                    <Text
                        label={`✅\nTu promoción fue\ncreada con exito`}
                        fontSize={32}
                        fontWeight={600}
                        textAlign={'center'}
                        fontFamily={'Poppins'}
                        color={'#565656'}
                        lineHeight={1}
                    />
                </div>
                <div
                    className="continue-button-container"
                    onClick={() => navigate(`/${routes.promotionMain}`)}
                >
                    <Text
                        label="Continuar"
                        fontSize={16}
                        fontWeight={600}
                        color="white"
                        textAlign="center"
                    />
                </div>
            </div>
        </div>
    )
}

export default PromotionCreated
